// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"DTGProductsList_contentComponent__swe06","tableContainer":"DTGProductsList_tableContainer__3or0C"};